import React from 'react';
import Slide, { ISlide } from '../../../../core/Slide';
import AgentTokyo from '../../characters/AgentTokyo';
import { DialogueData } from '../../../../general/Dialogue';
import { CharacterDialogue } from '../../../../general/Character';
import useFooterButtonRenderer from '../../../../misc/FooterButtonRenderer';
import { DiamondData } from '../..';
import { t } from 'ttag';
import AgentRio from '../../characters/AgentRio';

const TuringOutro: React.FC<ISlide<DiamondData>> = ({ defaultHeader, nextSlide, data }) => {
    const [footer, buttonRenderer] = useFooterButtonRenderer();

    const dialogue: DialogueData[] = [
        {
            character: AgentTokyo,
            text: t`Nice to meet you, Agent ${data.name}. I am ${AgentTokyo.characterName} and will be helping you break into the vault that Dr Mischief has stored the diamond in.`,
            buttonText: t`Next`,
        },
        {
            character: AgentTokyo,
            text: t`Our teammate ${AgentRio.characterName} will also be helping you get through some of the challenges Dr Mischief has in store for us in his lair.`,
            buttonText: t`Next`,
            buttonAction: nextSlide,
        },
    ];

    return (
        <Slide header={defaultHeader} footer={footer}>
            <CharacterDialogue dialogue={dialogue} buttonHandler={buttonRenderer} />
        </Slide>
    );
};

export default TuringOutro;
